const helpLinks = [
  { href: "#guide", label: "网站打不开" },
  { href: "#guide", label: "加载慢提速" },
  { href: "#guide", label: "换源指南" },
  { href: "#guide", label: "收藏同步" },
  { href: "#guide", label: "搜索技巧" },
  { href: "#guide", label: "登录账号" },
];

const siteLinks = [
  { href: "#beginner", label: "新手入门" },
  { href: "#faq", label: "常见问题" },
  { href: "#about", label: "关于我们" },
  { href: "#contact", label: "联系我们" },
];

export default function Footer() {
  return (
    <footer className="border-t border-background-300 bg-background-200">
      <div className="container-x grid gap-10 py-12 md:grid-cols-2 md:py-16 lg:grid-cols-4">
        <div className="lg:col-span-2">
          <a href="#top" className="flex items-center gap-2.5">
            <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-primary-500 font-heading text-lg text-background-50">
              笔
            </span>
            <span className="font-heading text-xl text-foreground-950">笔笔漫画网</span>
          </a>
          <p className="mt-4 max-w-md text-sm leading-relaxed text-foreground-700">
            笔笔漫画网使用问题帮助中心，汇总网站打不开、加载慢、换源、收藏、搜索、登录等常见问题的解决入口，帮助你快速定位原因并恢复顺畅阅读。
          </p>
          <div className="mt-5 flex items-center gap-3">
            <a href="#contact" aria-label="邮件联系" className="flex h-10 w-10 items-center justify-center rounded-lg bg-background-50 text-foreground-700 ring-1 ring-background-300 transition-colors hover:text-primary-600">
              <i className="ri-mail-line"></i>
            </a>
            <a href="#contact" aria-label="在线客服" className="flex h-10 w-10 items-center justify-center rounded-lg bg-background-50 text-foreground-700 ring-1 ring-background-300 transition-colors hover:text-primary-600">
              <i className="ri-customer-service-2-line"></i>
            </a>
            <a href="#faq" aria-label="帮助中心" className="flex h-10 w-10 items-center justify-center rounded-lg bg-background-50 text-foreground-700 ring-1 ring-background-300 transition-colors hover:text-primary-600">
              <i className="ri-question-line"></i>
            </a>
          </div>
        </div>

        <nav aria-label="帮助主题">
          <h3 className="font-heading text-base text-foreground-950">帮助主题</h3>
          <ul className="mt-4 space-y-2.5">
            {helpLinks.map((l) => (
              <li key={l.label}>
                <a href={l.href} className="text-sm text-foreground-700 transition-colors hover:text-primary-600">
                  {l.label}
                </a>
              </li>
            ))}
          </ul>
        </nav>

        <nav aria-label="站内链接">
          <h3 className="font-heading text-base text-foreground-950">快速入口</h3>
          <ul className="mt-4 space-y-2.5">
            {siteLinks.map((l) => (
              <li key={l.label}>
                <a href={l.href} className="text-sm text-foreground-700 transition-colors hover:text-primary-600">
                  {l.label}
                </a>
              </li>
            ))}
          </ul>
        </nav>
      </div>

      <div className="border-t border-background-300">
        <div className="container-x flex flex-col items-center justify-between gap-3 py-6 text-center sm:flex-row sm:text-left">
          <p className="text-xs text-foreground-600">
            © {new Date().getFullYear()} 笔笔漫画网 使用帮助中心 · 本页面仅提供平台使用问题说明
          </p>
          <p className="text-xs text-foreground-600">愿你追更顺利，阅读愉快</p>
        </div>
      </div>
    </footer>
  );
}